import {
  Component,
  OnInit,
  ViewEncapsulation,
  ViewChild,
  inject,
} from '@angular/core';
import {
  FormGroup,
  FormsModule,
  NgForm,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MaskService } from '../../services/mask.service';

import { PercentPipe } from '@angular/common';
import { MaskitoDirective } from '@maskito/angular';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-custom-model-dialog',
  templateUrl: './custom-model-dialog.component.html',
  styleUrls: ['./custom-model-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    PercentPipe,
    MaskitoDirective,
    ReactiveFormsModule,
    FormsModule,
    MatDialogModule,
    MatInputModule,
    MatButtonModule,
  ],
})
export class CustomModelDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<CustomModelDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);
  private mask = inject(MaskService);

  modelForm: NgForm;
  @ViewChild('modelForm', { static: true }) private form: FormGroup;

  classes = [];
  model = {};
  percentMask = this.mask.percentMaskSpecs();
  percentAllocated: number = 100;

  ngOnInit() {
    this.formatModel();
  }

  formatModel() {
    const model = this.data.model ? this.data.model : { allocations: [] };

    this.classes = model.allocations;
    model.allocations.forEach(el => {
      this.model['cm-' + el.AssetClassID] = el.Percent * 100;
    });
  }

  cancel() {
    this.dialogRef.close({ data: 'cancel' });
  }

  save() {
    const data = {};
    this.validateTotal();

    Object.keys(this.model).forEach(e => {
      data[e.replace('cm-', '')] = this.removePercentMask(this.model[e]);
    });
    if (this.form.valid) {
      this.dialogRef.close({ data: data });
      this.dialogRef.afterClosed().subscribe(() => {
        this.dialogRef = null;
      });
    }
  }

  addEntries() {
    const values = [];

    Object.keys(this.model).forEach(e => {
      values.push(this.removePercentMask(this.model[e]));
    });

    this.percentAllocated = values.reduce(function (a, b) {
      return Number(a) + Number(b);
    }, 0);

    return this.percentAllocated;
  }

  validateTotal() {
    const total = this.addEntries();
    let valid = false;

    valid = 100 === total;

    if (valid) {
      Object.keys(this.form.controls).forEach(x => {
        this.form.controls[x].setErrors(null);
        this.form.controls[x].markAsTouched();
      });

      return { totalValid: valid };
    } else {
      Object.keys(this.form.controls).forEach(x => {
        this.form.controls[x].setErrors({ notEqual: true });
        this.form.controls[x].markAsTouched();
      });
    }
  }

  removePercentMask(obj) {
    if (typeof obj === 'string' || obj instanceof String) {
      // eslint-disable-next-line no-useless-escape
      return Number(obj.replace(/\,/gi, '').replace('%', ''));
    }
    return Number(obj);
  }
}
